<template>
    <prism-editor v-model="code" :highlight="highlighter" @input="$emit('input', code)"></prism-editor>
</template>
  
<script>
// import Prism Editor
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-css';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles

export default {
    components: {
        PrismEditor,
    },
    props: {
        value: { type: String, default: "" }
    },
    data(){
        return {
            code: this.$props.value || ""
        }
    },
    methods: {
        highlighter(code) {
            console.log({
                ...languages.markup,
                ...languages.js,
                ...languages.css,
            });
            return highlight(code, {
                ...languages.markup,
                ...languages.js,
                ...languages.css,
            }, "markup"); // languages.<insert language> to return html with markup
        },
    },
    watch: {
        value(value){
            if(this.code != value) this.code = value;
        }
    }
};
</script>
  
<style scoped>
/* required class */
* {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #2d2d2d;
    color: #ccc;

    /* you must provide font-family font-size line-height. Example: */
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
}

/* optional class for removing the outline */
* >>> .prism-editor__textarea:focus {
    outline: none;
}

* >>> code[class*="prism-"],
* >>> pre[class*="prism-"] {
    color: #ABB2BF;
    /* background: #383e49; */
    text-align: left;
    /* white-space: pre; */
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
    overflow-x: scroll;
}

* >>> pre[class*="prism-"]::-moz-selection,
* >>> pre[class*="prism-"] ::-moz-selection,
* >>> code[class*="prism-"]::-moz-selection,
* >>> code[class*="prism-"] ::-moz-selection {
    text-shadow: none;
    /* background: #383e49; */
}

* >>> pre[class*="prism-"]::selection,
* >>> pre[class*="prism-"] ::selection,
* >>> code[class*="prism-"]::selection,
* >>> code[class*="prism-"] ::selection {
    text-shadow: none;
    background: #9aa2b1;
}

@media print {

    * >>> code[class*="prism-"],
    * >>> pre[class*="prism-"] {
        text-shadow: none;
    }
}

/* Code blocks */
* >>> pre[class*="prism-"] {
    /* padding: 1em; */
    /* margin: .5em 0; */
    overflow: auto;
}

* >>> :not(pre)>code[class*="prism-"],
* >>> pre[class*="prism-"] {
    /* background: #282c34; */
}

/* Inline code */
* >>> :not(pre)>code[class*="prism-"] {
    /* padding: .1em; */
    border-radius: .3em;
    white-space: normal;
}

* >>> .token.comment,
* >>> .token.prolog,
* >>> .token.doctype,
* >>> .token.cdata {
    color: #5C6370;
}

* >>> .token.punctuation {
    color: #abb2bf;
}

* >>> .token.property,
* >>> .token.keyword,
* >>> .token.tag {
    color: #e06c75;
}


* >>> .token.boolean,
* >>> .token.number,
* >>> .token.constant,
* >>> .token.symbol,
* >>> .token.attr-name,
* >>> .token.deleted {
    color: #d19a66;
}

* >>> .token.string,
* >>> .token.char,
* >>> .token.attr-value,
* >>> .token.builtin,
* >>> .token.inserted {
    color: #98c379;
}

* >>> .token.operator,
* >>> .token.entity,
* >>> .token.url,
* >>> .language-css .token.string,
* >>> .style .token.string {
    color: #56b6c2;
}

* >>> .token.atrule,
* >>> .token.keyword {
    color: #c678dd;
}

* >>> .token.selector,
* >>> .token.function {
    color: #61afef;
}

* >>> .token.regex,
* >>> .token.important,
* >>> .token.variable {
    color: #c678dd;
}

* >>> .token.important,
* >>> .token.bold {
    font-weight: bold;
}

* >>> .token.italic {
    font-style: italic;
}

* >>> .token.entity {
    cursor: help;
}

* >>> pre.line-numbers {
    position: relative;
    /* padding-left: 3.8em; */
    counter-reset: linenumber;
}

* >>> pre.line-numbers>code {
    position: relative;
}

* >>> .line-numbers .line-numbers-rows {
    position: absolute;
    pointer-events: none;
    top: 0;
    font-size: 100%;
    left: -3.8em;
    width: 3em;
    /* works for line-numbers below 1000 lines */
    letter-spacing: -1px;
    border-right: 0;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

}

* >>> .line-numbers-rows>span {
    pointer-events: none;
    display: block;
    counter-increment: linenumber;
}

* >>> .line-numbers-rows>span:before {
    content: counter(linenumber);
    color: #5C6370;
    display: block;
    /* padding-right: 0.8em; */
    text-align: right;
}
</style>